var map = {
	"./aweme.png": "b6f4",
	"./ohayoo.png": "8db8",
	"./tomato_novel_app.png": "8463",
	"./toutiao.png": "edb5",
	"./union.png": "a8cc",
	"./video_app.png": "2b63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc00";